<template>
  <div class="wrap">
    <div :style="account == '3' ? 'width:49%;height: 88.9vh;' : ''">
    <Card class="" v-if="account == '3'">
      <p slot="title" style="height:3vh">送审实时数据</p>
      <div class="left-map">
        <div class="map-title">
          <!-- <h3>送审实时数据</h3> -->
          <span><i></i></span>
          <div class="online-count">
            <label style="width: 48%;text-align: center"><label style="font-size: 30px">{{schoolYear}}年</label></label>
            <label style="width: 48%;text-align: center"><label style="font-size: 30px;color: #f5a623">{{schoolSeason}}</label></label>
          </div>
          <div class="online-count">
            <label style="width: 24%;text-align: center">送审总数<label style="font-size: 50px">{{mapCount.count}}</label></label>
            <label style="width: 24%;text-align: center">提交总数<label style="font-size: 50px;color: #f5a623">{{mapCount.reviewedCount}}</label></label>
            <label style="width: 24%;text-align: center">今日提交<label style="font-size: 50px">{{mapCount.increase}}</label></label>
            <label style="width: 24%;text-align: center">评阅中数<label style="font-size: 50px;color: #f5a623">{{mapCount.reviewingCount}}</label></label>
          </div>
        </div>
        <div class="map-graph" id="chinaCount">
        </div>
      </div>
    </Card>
    </div>
    <div class="right-count-graph" v-if="account == '3'">
      <div style="width:49%;margin-right:2%;margin-bottom:1vh">
      <Card class="" :bordered="false">
        <p slot="title" style="height:3vh">评阅意见占比</p>
        <div class="graph-item">
          <div class="" id="commentResult"></div>
        </div>
      </Card>
      </div>
      <div style="width:49%;margin-bottom:1vh">
      <Card class="" :bordered="false">
        <p slot="title" style="height:3vh">评审单位类型占比</p>
        <div class="graph-item">
          <div id="unitType"></div>
        </div>
      </Card>
      </div>
      <div style="width:49%;margin-right:2%">
      <Card class="" :bordered="false">
        <p slot="title" style="height:3vh">总体评价分布</p>
        <div class="graph-item" style="margin-bottom:0">
          <div id="evaluate"></div>
        </div>
      </Card>
      </div>
      <div style="width:49%">
      <Card class="" :bordered="false">
        <p slot="title" style="height:3vh">专家熟悉程度占比</p>
        <div class="graph-item" style="margin-bottom:0">
          <div id="familiarity"></div>
        </div>
      </Card>
      </div>
      <!--<div class="graph-item">
        <div class="" id="provincialRanking"></div>
      </div>-->
      <!--<div class="graph-item" style="width: 100%">
        <div class="" id="unitRanking"></div>
      </div>-->
    </div>
    <h1 class="center-h1" v-else>欢迎使用匡汇科技<br>研究生学位论文质量送审平台！</h1>
  </div>
</template>

<script>
export default {
  data () {
    return {
      mapCount: {},
      mapChart: null,
      commentChart: null,
      schoolYear: '',
      schoolSeason: '',
      commentLoop: {
        index: 0,
        data: [],
        timer: null
      },
      accountType: '',
      unitTypeChart: null,
      provincialRankingChart: null,
      unitRankingChart: null,
      evaluateChart: null,
      evaluateLoop: {
        index: 0,
        data: [],
        timer: null
      },
      familiarityChart: null,
      familiarityLoop: {
        index: 0,
        data: [],
        timer: null
      }
    }
  },
  created () {
    this.account = this.$store.state.role.accountType
    console.log(this.$store.state.role.accountType, 'account', this.account === '3')
  },
  mounted () {
    if (this.account === '3') {
      this.post(`/school/schoolQuarter/getCurrentSchoolSeason`)
        .then((res) => {
          this.schoolYear = res.data.auditYear
          this.schoolSeason = res.data.seasonName
          setTimeout(() => {
            this.initCharts();
          });
        })
        .catch((error) => {
          console.log(error)
        });
    }
  },
  methods: {
    initCharts () {
      const _self = this;
      _self.mapChart = echarts.init(document.getElementById('chinaCount'), 'cndatahub');
      _self.commentChart = echarts.init(document.getElementById('commentResult'), 'cndatahub');
      _self.unitTypeChart = echarts.init(document.getElementById('unitType'), 'cndatahub');
      _self.evaluateChart = echarts.init(document.getElementById('evaluate'), 'cndatahub');
      _self.familiarityChart = echarts.init(document.getElementById('familiarity'), 'cndatahub');
      _self.mapChart.showLoading();
      _self.commentChart.showLoading();
      _self.unitTypeChart.showLoading();
      _self.evaluateChart.showLoading();
      _self.familiarityChart.showLoading();
      //
      _self.post('/school/statistics/count').then(res => {
        _self.mapCount = JSON.parse(res.data);
      })
      // 全国评阅统计
      _self.post('/school/statistics/province', {}).then(res => {
        _self.mapChart.hideLoading();
        let result = JSON.parse(res.data.replace(/省|市/g, ''));
        let chartData = [];
        let largest = 0;
        for (let item of result) {
          if (largest < item.count) largest = item.count;
          chartData.push({
            name: item.provinceName,
            value: item.count
          })
        }
        let option = {
          grid: {
            containLabel: true
          },
          tooltip: {
            trigger: 'item',
            showDelay: 0,
            transitionDuration: 0.2,
            formatter: function (params) {
              if (params.value) {
                var value = (params.value + '').split('.');
                value = value[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,');
                return params.name + ': ' + (value || 0);
              } else {
                return params.name + ': 0';
              }
            }
          },
          visualMap: {
            left: 'left',
            min: 0,
            max: largest,
            inRange: {
              color: ['#EBF7FB', '#1890FF']
            },
            text: ['送审数', ''], // 文本，默认为数值文本
            calculable: true
          },
          series: [{
            name: '送审实时数据',
            type: 'map',
            roam: true,
            map: 'china',
            itemStyle: {
              emphasis: {label: {show: true}}
            },
            // 文本位置修正
            textFixed: {
              Alaska: [0, 0]
            },
            data: chartData
          }]
        }
        _self.mapChart.setOption(option);
      });
      // 评阅意见占比
      _self.post('/school/statistics/reviewResult', {}).then(res => {
        let result = JSON.parse(res.data);
        let graphData = [];
        let legendData = [];
        for (let item of result) {
          let itemData = [];
          for (let i of item.list) {
            itemData.push({
              name: i.reviewResult,
              value: i.count
            })
            if (!legendData.includes(i.reviewResult)) {
              legendData.push(i.reviewResult);
            }
          }
          graphData.push({
            title: item.degree.name,
            data: itemData
          })
        }
        _self.commentLoop.data = graphData;
        _self.commentLoop.legendData = legendData;
        if (_self.commentLoop.data.length > 0) {
          _self.commentOneLoop();
        }
        _self.commentChart.hideLoading();
        if (graphData.length > 1) {
          _self.timer = setInterval(_self.commentOneLoop, 10000);
        }
      });
      // 评审单位类型占比
      _self.post('/school/statistics/unitType', {}).then(res => {
        let result = JSON.parse(res.data);
        let graphData = [];
        let legendData = [];
        for (let item of result) {
          graphData.push({
            name: item.schoolType,
            value: item.count
          });
          if (!legendData.includes(item.schoolType)) legendData.push(item.schoolType);
        }
        if (graphData.length > 0) {
          _self.unitTypeChart.setOption({
            title: {
              text: '',
              x: 'left'
            },
            color: ['#1890FF', '#36CBCB', '#4ECB74', '#FAD337', '#F2637B'],
            grid: {
              containLabel: true
            },
            tooltip: {
              trigger: 'item',
              formatter: '{b} : {c} ({d}%)'
            },
            series: [{
              type: 'pie',
              radius: '50%',
              center: ['50%', '40%'],
              labelLine: {
                normal: {
                  length: 1
                }
              },
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              roseType: 'radius',
              data: graphData
            }]
          });
        }
        _self.unitTypeChart.hideLoading();
      })
      // 总体评价分布
      _self.post('/school/statistics/evaluation', {}).then(res => {
        let result = JSON.parse(res.data);
        let graphData = [];
        for (let item of result) {
          let xdata = [];
          let ydata = [];
          for (let i of item.list) {
            xdata.push(i.evaluation)
            ydata.push(i.count)
          }
          graphData.push({
            title: item.degree.name,
            xdata: xdata,
            ydata: ydata
          })
        }

        _self.evaluateLoop.data = graphData;
        if (_self.evaluateLoop.data.length > 0) {
          _self.evaluateOneLoop();
        }
        _self.evaluateChart.hideLoading();

        if (graphData.length > 1) {
          _self.evaluateLoop.timer = setInterval(_self.evaluateOneLoop, 10000);
        }
      });
      // 专家熟悉程度占比
      _self.post('/school/statistics/familiarLevel', {}).then(res => {
        let result = JSON.parse(res.data);
        let graphData = [];
        let legendData = [];
        for (let item of result) {
          let itemData = [];
          for (let i of item.list) {
            itemData.push({
              name: i.familiarLevel,
              value: i.count
            });
            if (!legendData.includes(i.familiarLevel)) legendData.push(i.familiarLevel)
          }
          graphData.push({
            title: item.degree.name,
            data: itemData
          })
        }
        _self.familiarityLoop.data = graphData;
        _self.familiarityLoop.legendData = legendData;
        if (_self.familiarityLoop.data.length > 0) {
          _self.familiarityOneLoop();
        }
        _self.familiarityChart.hideLoading();

        if (graphData.length > 1) {
          _self.familiarityLoop.timer = setInterval(_self.familiarityOneLoop, 10000);
        }
      });
    },
    evaluateOneLoop () {
      const _self = this;
      _self.evaluateChart.setOption({
        title: {
          text: '',
          subtext: _self.evaluateLoop.data[_self.evaluateLoop.index].title,
          x: 'left'
        },
        color: ['#1890FF'],
        grid: {
          containLabel: true,
          top: '80',
          bottom: '5%'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          },
          formatter: '{a} <br/> {b} : {c}'
        },
        xAxis: {
          data: _self.evaluateLoop.data[_self.evaluateLoop.index].xdata,
          axisTick: {show: false},
          axisLine: {show: false},
          axisLabel: {
            textStyle: {
            }
          }
        },
        yAxis: {
          splitLine: {show: false},
          axisTick: {show: false},
          axisLine: {show: false},
          axisLabel: {show: false}
        },
        series: [{
          name: _self.evaluateLoop.data[_self.evaluateLoop.index].title,
          type: 'pictorialBar',
          barCategoryGap: '-130%',
          symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          itemStyle: {
            normal: {
              opacity: 0.5
            },
            emphasis: {
              opacity: 0.9
            }
          },
          data: _self.evaluateLoop.data[_self.evaluateLoop.index].ydata,
          z: 1
        }]
      });
      _self.evaluateLoop.index = (_self.evaluateLoop.index + 1) % _self.evaluateLoop.data.length;
    },
    commentOneLoop () {
      const _self = this;
      _self.commentChart.setOption({
        title: {
          text: '',
          subtext: _self.commentLoop.data[_self.commentLoop.index].title,
          x: 'left'
        },
        color: ['#1890FF', '#975FE4'],
        grid: {
          containLabel: true
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        series: [
          {
            name: _self.commentLoop.data[_self.commentLoop.index].title,
            type: 'pie',
            radius: '50%',
            center: ['50%', '40%'],
            labelLine: {
              normal: {
                length: 10
              }
            },
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            roseType: 'area',
            data: _self.commentLoop.data[_self.commentLoop.index].data
          }
        ]
      });
      _self.commentLoop.index = (_self.commentLoop.index + 1) % _self.commentLoop.data.length;
    },
    familiarityOneLoop () {
      const _self = this;
      _self.familiarityChart.setOption({
        title: {
          text: '',
          subtext: _self.familiarityLoop.data[_self.familiarityLoop.index].title,
          x: 'left'
        },
        color: ['#1890FF'],
        grid: {
          containLabel: true
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/> {b} : {c} ({d}%)'
        },
        series: [{
          name: _self.familiarityLoop.data[_self.familiarityLoop.index].title,
          type: 'pie',
          radius: '50%',
          center: ['50%', '40%'],
          avoidLabelOverlap: true,
          hoverOffset: 0,
          hoverAnimation: false,
          silent: true,
          labelLine: {
            normal: {
              length: 10
            }
          },
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          data: _self.familiarityLoop.data[_self.familiarityLoop.index].data
        }]
      });
      _self.familiarityLoop.index = (_self.familiarityLoop.index + 1) % _self.familiarityLoop.data.length;
    }
  }
}
</script>

<style lang="less" scoped>
  .kh-card-bordered {
    border: 0;
  }
  h1.center-h1 {
    margin-top: 15%;
    text-transform: uppercase;
    display: block;
    font-size: 35px;
    line-height: 100px;
    color: @base-color;
    text-shadow: -6px 8px 8px rgba(@base-color, .5);
    font-weight: bold;
    letter-spacing: 16px;
    text-align: center;
    padding: 0 60px;
  }
  .wrap {
    width: 100%;
    align-items: stretch;
    flex-flow: nowrap;
    justify-content: center;
    .left-map {
      min-width: 450px;
      margin-right: 2%;
      width: 100%;
      height: 77vh;
      display: flex;
      flex-direction: column;
      .map-title {
        height: 10vh;
        margin-bottom: 3vh;
        padding: 0 20px;
        h3 {
          color: @base-color;
          font-size: 24px;
        }
        .online-count {
          // margin-top: 20px;
          label {
            display: inline-block;
            font-size: 16px;
            &.right {
              float: right;
            }
            label {
              color: @base-color;
              display: block;
              font-weight: bold;
              font-size: 24px;
            }
          }
        }
      }
      .map-graph {
        width: 100%;
        flex: 1;
        display: flex;
        align-items: center;
      }
    }
    .right-count-graph {
      width: 50%;
      display: flex;
      flex: 1;
      flex-flow: wrap;
      justify-content: space-between;
      align-content: flex-start;
      margin-left: 1%;
      height: 88.9vh;
      .graph-item {
        // height: 42%;
        // width: 50%;
        // margin-top: 5%;
        height: calc(36.5vh - 32px);
        width: 100%;
        > div {
          height: 100%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/home/home.vue